import * as types from "../actions/actionTypes";
const initialState = {
  loading: false,
  data: {prices: []},
  calculatePrice: {},
  calculatePricePostData: {},
  calculatePriceLoading: false,
  calculatePriceError: false,
  useWalletLoading: false,
  usePromoCodeLoading: false,
  list: [],
  listByProject: [],
  payLoading: false,
  promoCodeLoading: false,
  payData: [],
  promoCodes: []
};

const Premium = (state = initialState, action) => {
  switch (action.type) {
    case types.PREMIUM_INIT_REQUEST:
      return { ...state, loading: true };
    case types.PREMIUM_INIT_SUCCESS:
      return { ...state, data: action.payLoad, loading: false };
    case types.PREMIUM_INIT_FAILURE:
      return { ...state, loading: false };

    case types.PREMIUM_CALCULATE_PRICE_REQUEST:
      return {
        ...state,
        calculatePriceLoading: true,
        calculatePriceError: false
      };
    case types.PREMIUM_CALCULATE_PRICE_SUCCESS:
      return {
        ...state,
        calculatePrice: action.payLoad,
        calculatePriceLoading: false,
        calculatePricePostData: action.postedData
      };
    case types.PREMIUM_CALCULATE_PRICE_FAILURE:
      return {
        ...state,
        calculatePriceLoading: false,
        calculatePriceError: true,
        calculatePricePostData: action.postedData
      };

    case types.PREMIUM_USE_WALLET_REQUEST:
      return { ...state, useWalletLoading: true };
    case types.PREMIUM_USE_WALLET_SUCCESS:
      return {
        ...state,
        calculatePrice: action.payLoad,
        useWalletLoading: false
      };
    case types.PREMIUM_USE_WALLET_FAILURE:
      return {
        ...state,
        useWalletLoading: false
      };

    case types.PREMIUM_USE_PROMO_CODE_REQUEST:
      return { ...state, usePromoCodeLoading: true };
    case types.PREMIUM_USE_PROMO_CODE_SUCCESS:
      return {
        ...state,
        calculatePrice: action.payLoad,
        usePromoCodeLoading: false
      };
    case types.PREMIUM_USE_PROMO_CODE_FAILURE:
      return {
        ...state,
        usePromoCodeLoading: false
      };

    case types.PREMIUM_INFO_SAVE_IN_CASH:
      return { ...state, calculatePricePostData: action.data };

    case types.PREMIUM_TRANSACTION_LIST_REQUEST:
      return { ...state, loading: true };
    case types.PREMIUM_TRANSACTION_LIST_SUCCESS:
      return { ...state, list: action.payLoad.data, loading: false };
    case types.PREMIUM_TRANSACTION_LIST_FAILURE:
      return { ...state, loading: false };

    case types.PREMIUM_TRANSACTION_LIST_BY_PROJECT_REQUEST:
      return { ...state, loading: true };
    case types.PREMIUM_TRANSACTION_LIST_BY_PROJECT_SUCCESS:
      return { ...state, listByProject: action.payLoad, loading: false };
    case types.PREMIUM_TRANSACTION_LIST_BY_PROJECT_FAILURE:
      return { ...state, loading: false };

    case types.PREMIUM_PAY_REQUEST:
      return { ...state, payLoading: true };
    case types.PREMIUM_PAY_SUCCESS:
      return { ...state, payData: action.data, payLoading: false };
    case types.PREMIUM_PAY_FAILURE:
      return { ...state, payLoading: false };

    case types.PREMIUM_PROMO_CODE_REQUEST:
      return { ...state, promoCodeLoading: true };
    case types.PREMIUM_PROMO_CODE_SUCCESS:
      return { ...state, promoCodes: action.data, promoCodeLoading: false };
    case types.PREMIUM_PROMO_CODE_FAILURE:
      return { ...state, promoCodeLoading: false };

    default:
      return state;
  }
};

export default Premium;
